module.exports = __webpack_public_path__ + "static/media/8000.99c3ad68.jpg";